import './App.css';
import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Components/Auth/Login';
import Signup from './Components/Auth/Signup';
import Overview from './Components/Main/Overview';
import Home from './Components/Main/Home';
import Transactions from './Components/Main/Transactions';
import QATicket from './Components/Main/QATicket';
import Settings from './Components/Main/Settings';
import Payment from './Components/Main/Payment';
import Invoice from './Components/Main/invoice';
import Website from './Components/Main/Websites';
import Publishers from './Components/Main/Publishers';
import ProtectedRoute from './Components/Auth/ProtectedRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './Components/Auth/AuthContext';
import Analytics from './Components/Main/Analytics';
import Adunits from './Components/Main/Adunits';
import AdsTxtConfiguration from './Components/Main/AdsTxtConfiguration';
import AdsCodeConfiguration from './Components/Main/AdsCodeConfiguration';
import AdminSettings from './Components/Main/AdminSettings';
import Notes from './Components/Main/Notes';
import PaymentDetails from './Components/Payment/PaymentDetails';
import Adscode from './Components/Main/Adscode';

function App() {
  return (
    <AuthProvider>
      <ToastContainer />
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* Protected Routes */}
          <Route
            path="/overview"
            element={
              <ProtectedRoute >
                <Overview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            }
          />
                   <Route
            path="/adunits"
            element={
              <ProtectedRoute>
                <Adunits />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <ProtectedRoute>
                <Transactions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/qa-tickets"
            element={
              <ProtectedRoute>
                <QATicket />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <Payment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoice"
            element={
              <ProtectedRoute>
                <Invoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment-info"
            element={
              <ProtectedRoute>
                <PaymentDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/website"
            element={
              <ProtectedRoute>
                <Website />
              </ProtectedRoute>
            }
          />
               <Route
            path="/AdsTxtConfiguration"
            element={
              <ProtectedRoute>
                <AdsTxtConfiguration />
              </ProtectedRoute>
            }
          />
           <Route
            path="/AdsCodeConfiguration"
            element={
              <ProtectedRoute>
                <AdsCodeConfiguration />
              </ProtectedRoute>
            }
          />
               <Route
            path="/adscode"
            element={
              <ProtectedRoute>
                <Adscode />
              </ProtectedRoute>
            }
          />

          {/* Admin-Only Route */}
          <Route
            path="/publishers"
            element={
              <ProtectedRoute requiredRole="Admin">
                <Publishers />
              </ProtectedRoute>
            }
          />
              <Route
            path="/adminsetting"
            element={
              <ProtectedRoute requiredRole="Admin">
                <AdminSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notes"
            element={
              <ProtectedRoute requiredRole="Admin">
                <Notes />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
